import { printHTML, downloadWord } from '../utils/printHelper';
import { useEffect, useState } from 'react';
import { api } from '../App';
import { toast } from 'sonner';
import { formatDatePrint } from '../utils/dateFormat';
import { DateInput } from '../components/DateInput';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card } from '@/components/ui/card';
import { Plus, Pencil, Trash, Printer, FileDoc, Hammer } from '@phosphor-icons/react';
import { confirmDialog } from '@/components/ConfirmDialog';
import ClientAutocomplete from '../components/ClientAutocomplete';

export default function PrijavaZanatstvaPage() {
  const [zahtjevi, setZahtjevi] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const emptyForm = {
    vrsta_zahtjeva: 'prijava_zanatstva', client_id: '', datum_podnosenja: new Date().toISOString().split('T')[0],
    pz_predmet_prijave: 'pocetak',
    pz_naziv_ime: '', pz_sjediste_adresa: '', pz_broj_rjesenja: '', pz_sifra_djelatnosti: '',
    pz_ovlasceno_lice: '', pz_broj_licne_karte: '', pz_ziro_racun: '', pz_poreski_broj: '',
    pz_telefon_fax_email: '',
    pz_vrsta_zanata: '', pz_zanatska_djelatnost: '', pz_osnovna_dopunska: 'osnovna',
    pz_prostor_tip: 'poslovni',
    pz_pp_sjediste: '', pz_pp_adresa: '',
    pz_pp_poslovni: false, pz_pp_poslovni_m2: '',
    pz_pp_stambeni: false, pz_pp_stambeni_m2: '',
    pz_datum_pocetka_rada: '', pz_vrsta_promjene: '', pz_datum_promjene: '',
    napomena: '',
  };
  const [form, setForm] = useState(emptyForm);

  useEffect(() => { fetchData(); }, []);
  const fetchData = async () => {
    try {
      const [z, c] = await Promise.all([api.get('/zahtjevi?vrsta=prijava_zanatstva'), api.get('/clients')]);
      setZahtjevi(z.data); setClients(c.data);
    } catch { toast.error('Greška'); } finally { setLoading(false); }
  };

  const handleClientSelect = (cid) => {
    const c = clients.find(cl => cl.id === cid);
    if (c) setForm(prev => ({
      ...prev, client_id: cid,
      pz_naziv_ime: c.naziv_firme || c.skraceni_naziv || '',
      pz_sjediste_adresa: [c.adresa, c.grad].filter(Boolean).join(', '),
      pz_broj_rjesenja: c.registarski_broj || '',
      pz_sifra_djelatnosti: c.djelatnost || '',
      pz_poreski_broj: c.pib || '',
      pz_ovlasceno_lice: c.direktor || '',
      pz_telefon_fax_email: [c.telefon, c.email].filter(Boolean).join(', '),
      pz_ziro_racun: c.pt_ziro_racun || '',
      pz_pp_sjediste: c.adresa || '',
      pz_pp_adresa: c.grad || '',
    }));
  };

  useEffect(() => {
    if (isFormOpen && form.client_id && clients.length > 0 && !form.pz_naziv_ime) {
      handleClientSelect(form.client_id);
    }
  }, [isFormOpen, clients]);

  const handleSubmit = async () => {
    if (!form.pz_naziv_ime) { toast.error('Unesite naziv/ime zanatlije'); return; }
    try {
      if (editingId) { await api.put(`/zahtjevi/${editingId}`, form); toast.success('Ažurirano'); }
      else { await api.post('/zahtjevi', form); toast.success('Kreirano'); }
      setIsFormOpen(false); setEditingId(null); setForm(emptyForm); fetchData();
    } catch (e) { toast.error(e.response?.data?.detail || 'Greška'); }
  };

  const handleEdit = (z) => {
    setEditingId(z.id);
    setForm({ ...emptyForm, ...z, pz_pp_poslovni: z.pz_pp_poslovni ?? false, pz_pp_stambeni: z.pz_pp_stambeni ?? false });
    setIsFormOpen(true);
  };

  const handleDelete = async (id) => {
    if (!(await confirmDialog('Obrisati?'))) return;
    try { await api.delete(`/zahtjevi/${id}`); toast.success('Obrisano'); fetchData(); } catch { toast.error('Greška'); }
  };

  const buildHtml = (z) => {
    const cb = (checked) => checked ? '&nbsp;X&nbsp;' : '________';
    return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Prijava zanatstva</title>
<style>
@page{size:A4;margin:12mm 18mm 10mm 18mm}
@media print{html,body{-webkit-print-color-adjust:exact}}
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'Times New Roman',Times,serif;font-size:11pt;color:#000;line-height:1.4;max-width:174mm;margin:0 auto}
.page{page-break-after:always;min-height:257mm;padding-bottom:8mm}
.page:last-child{page-break-after:auto}
.hdr{display:flex;justify-content:space-between;margin-bottom:6px}
.hdr-l{font-size:10pt;line-height:1.35}
.hdr-l .c{font-weight:bold;font-size:11pt}
.hdr-r{text-align:right;font-size:9.5pt;line-height:1.35}
.sep{border-top:1.5px solid #000;margin:5px 0}
.obr{text-align:right;font-size:10pt;font-weight:bold;margin:3px 0}
.cb{text-align:center;margin:6px 0}
.cb .org{font-weight:bold;font-size:10.5pt;line-height:1.3}
.cb .sub{font-size:8.5pt;font-style:italic;margin-top:1px}
.tit{text-align:center;font-weight:bold;font-size:13pt;text-transform:uppercase;margin:8px 0 2px}
.tit-s{text-align:center;font-size:9pt;font-style:italic;margin-bottom:6px}
.pred{margin:4px 0 4px 15px;font-size:10.5pt;line-height:1.6}
.pred-al{font-size:9pt;font-style:italic;margin-left:5px}
.st{font-weight:bold;font-size:11pt;margin:8px 0 3px}
.fr{margin:3px 0 3px 12px;font-size:10.5pt;display:flex;align-items:baseline}
.fl{margin-right:5px;white-space:nowrap}
.fv{flex:1;border-bottom:1px solid #000;min-height:15px;padding:0 3px}
.sub-l{font-size:8.5pt;font-style:italic;margin:0 0 2px 12px;color:#333}
.sp{height:3px}
.cb-row{margin:3px 0 3px 20px;font-size:10.5pt}
.cbx{display:inline-block;width:80px;border-bottom:1px solid #000;text-align:center;margin:0 6px}
.izj{font-size:10pt;margin:6px 12px;line-height:1.3;text-align:justify}
.izj-al{font-size:9pt;font-style:italic;margin:4px 12px;line-height:1.25;text-align:justify}
.br{display:flex;align-items:baseline;margin:4px 0 4px 12px;font-size:10.5pt}
.bl{min-width:300px}
.bv{flex:1;border-bottom:1px solid #000;min-height:15px;padding:0 3px}
.sign{text-align:center;margin-top:20px}
.sign-l{border-top:1px solid #000;display:inline-block;min-width:350px;padding-top:2px;font-size:8.5pt;margin-top:25px}
.uput{margin-top:12px;font-size:8.5pt;line-height:1.25}
.uput-t{font-weight:bold;font-size:9pt;margin-bottom:2px}
.taxa{margin-top:8px;font-size:8.5pt;line-height:1.25}
.meta{margin-top:8px;font-size:7pt;color:#555}
@media print{.meta{display:none}}
</style></head><body>
<!-- STRANA 1 -->
<div class="page">
<div style="text-align:right;font-size:8.5pt;margin-bottom:2px">1/2</div>
<div class="hdr">
  <div class="hdr-l">
    <div class="c">CRNA GORA</div>
    <div>MALI I ZI</div>
    <div>Opština Ulcinj</div>
    <div style="font-style:italic;font-size:9pt">Komuna Ulqin</div>
    <div style="margin-top:2px;font-size:10pt">Sekretarijat za privredu i ekonomski razvoj</div>
    <div style="font-style:italic;font-size:9pt">Sekretariati për ekonomi dhe zhvillim ekonomik</div>
    <div style="margin-top:2px;font-size:10pt">Br./Nr.: 08-306</div>
    <div style="font-size:10pt">Ulcinj/Ulqin, ${formatDatePrint(z.datum_podnosenja) || ''}</div>
  </div>
  <div class="hdr-r">
    Adresa: Bul.Đ.Kastrioti Skenderbeg<br>
    85360 Ulcinj, Crna Gora<br>
    tel. 412-206<br>
    www.ul-gov.me
  </div>
</div>
<div class="sep"></div>
<div class="obr">Obrazac/Formulari 01</div>

<div class="cb">
  <div class="org">SEKRETARIJAT ZA PRIVREDU I EKONOMSKI RAZVOJ</div>
  <div class="org" style="font-style:italic;font-size:9.5pt">SEKRETARIATI PËR EKONOMI DHE ZHVILLIM EKONOMIK</div>
  <div class="sub">(naziv organa kojem se podnosi prijave/emri i organit të cilit i paraqitet fletëparaqitja)</div>
</div>
<div class="sep"></div>
<div class="tit-s">sjedište organa/selia e organit</div>
<div class="tit">PRIJAVA ZANATSTVA</div>

<div class="pred">
  početak obavljanja zanatstva <span class="cbx">${cb(z.pz_predmet_prijave === 'pocetak')}</span> 1)<br>
  <span class="pred-al">fillimi i ushtrimit të zejtarisë</span><br>
  promjena podataka iz prijave <span class="cbx">${cb(z.pz_predmet_prijave === 'promjena')}</span> 2)<br>
  <span class="pred-al">ndryshimi i të dhënave nga fletëparaqitja</span>
</div>

<div class="st">Podaci o zanatliji / Të dhënat për zejtarin:</div>

<div class="fr"><span class="fl">Naziv/ime/Emri</span><span class="fv">${z.pz_naziv_ime || '&nbsp;'}</span></div>
<div class="sub-l">(Privredno društvo/preduzetnik / Shoqëria ekonomike/sipërmarrësi)</div>

<div class="fr"><span class="fl">Sjedište/Selia</span><span class="fv">${z.pz_sjediste_adresa || '&nbsp;'}</span></div>
<div class="sub-l">adresa</div>

<div class="fr"><span class="fl">Broj i datum rješenja o upisu u Centralni Registar Privrednog Suda</span></div>
<div class="fr"><span class="fv">${z.pz_broj_rjesenja || '&nbsp;'}</span></div>
<div class="sub-l">Numri dhe data e aktvendimit të regjistrimit në Regjistrin qendror të Gjykatës ekonomike</div>

<div class="sep" style="margin-top:5px"></div>

<div class="fr"><span class="fl">Šifra djelatnosti / Shifra e aktivitetit</span><span class="fv">${z.pz_sifra_djelatnosti || '&nbsp;'}</span></div>

<div class="fr"><span class="fl">Ime lica ovlašćenog za zastupanje</span><span class="fv">${z.pz_ovlasceno_lice || '&nbsp;'}</span></div>
<div class="sub-l">Emri i personit të autorizuar për përfaqësim</div>
<div class="fr"><span class="fl">(broj lične karte ili pasoša)</span><span class="fv">${z.pz_broj_licne_karte || '&nbsp;'}</span></div>

<div class="sp"></div>
<div class="fr"><span class="fl">Žiro račun/i i poslovna banka</span><span class="fv">${z.pz_ziro_racun || '&nbsp;'}</span></div>
<div class="sub-l">Llogaria rrjedhëse dhe banka afariste</div>

<div class="sp"></div>
<div class="fr"><span class="fl">Poreski identifikacioni broj / Numri identifikues tatimor</span><span class="fv">${z.pz_poreski_broj || '&nbsp;'}</span></div>

<div class="sp"></div>
<div class="fr"><span class="fl">Telefon-i, fax-i, e-mail</span><span class="fv">${z.pz_telefon_fax_email || '&nbsp;'}</span></div>

<div class="st" style="margin-top:10px">Podaci o zanatliji / Të dhënat për zejtarin</div>
<div style="margin-left:12px;font-size:10.5pt">Vrsta zanata / Lloji i zejtarisë:</div>

<div class="fr"><span class="fl">jednostavni – složeni zanati / zejtari të thjeshta – avancuara:</span><span class="fv">${z.pz_vrsta_zanata || '&nbsp;'}</span></div>
<div class="fr"><span class="fl">zanatska djelatnost / aktiviteti zejtar:</span><span class="fv">${z.pz_zanatska_djelatnost || '&nbsp;'}</span></div>
<div class="fr"><span class="fl">osnovna – dopunska djelatnost / aktiviteti themelor – shtesë:</span><span class="fv">${z.pz_osnovna_dopunska === 'osnovna' ? 'osnovna' : 'dopunska'}</span></div>

<div class="cb-row">zanatstvo u – poslovnoj prostoriji / zejtaria në ambientin afarist <span class="cbx">${cb(z.pz_prostor_tip === 'poslovni')}</span></div>
<div class="cb-row">zanatstvo u – stambenoj prostoriji / zejtari në ambientin e banimit <span class="cbx">${cb(z.pz_prostor_tip === 'stambeni')}</span></div>
</div>

<!-- STRANA 2 -->
<div class="page">
<div style="text-align:right;font-size:8.5pt;margin-bottom:2px">2/2</div>

<div class="st">Podaci o poslovnoj prostoriji / Të dhënat për ambientin afarist:</div>
<div class="fr"><span class="fl">Sjedište / Selia:</span><span class="fv">${z.pz_pp_sjediste || '&nbsp;'}</span></div>
<div class="fr"><span class="fl">adresa:</span><span class="fv">${z.pz_pp_adresa || '&nbsp;'}</span></div>

<div style="margin:5px 0 3px 12px;font-size:10.5pt">Vrsta / Lloji: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Površina / Sipërfaqja:</div>
<div class="cb-row">poslovni prostor / ambienti afarist <span class="cbx">${cb(z.pz_pp_poslovni)}</span> &nbsp;&nbsp;&nbsp; <span style="border-bottom:1px solid #000;display:inline-block;width:70px;text-align:center">${z.pz_pp_poslovni_m2 || '&nbsp;'}</span> m²</div>
<div class="cb-row">stambeni prostor / ambienti i banimit <span class="cbx">${cb(z.pz_pp_stambeni)}</span> &nbsp;&nbsp;&nbsp; <span style="border-bottom:1px solid #000;display:inline-block;width:70px;text-align:center">${z.pz_pp_stambeni_m2 || '&nbsp;'}</span> m²</div>

<div class="st" style="margin-top:10px">Izjava o ispunjenosti minimalnih tehničkih uslova ***</div>
<div class="izj">
  Izjavljujem da su u poslovnoj prostoriji-stambenoj prostoriji iz tačke 2 ove prijave ispunjeni minimalno-tehnički uslovi u pogledu prostora, opreme i sredstava za obavljanje zanatske djelatnosti iz tačke 3 ove prijave, utvrđene propisom Ministarstva.
</div>
<div class="izj-al">
  Deklaroj që në ambientin afarist – ambientin e banimit nga pika 2 e kësaj fletëparaqitje janë plotësuar kushtet minimale teknike në aspektin e ambientit, pajisjeve dhe mjeteve për ushtrimin e aktivitetit të zejtarisë nga pika 3 e kësaj fletëparaqitje, të përcaktuara me dispozitat e Ministrisë.
</div>

<div class="sp"></div>
<div class="br"><span class="bl">Datum početka rada / Data e fillimit të punës</span><span class="bv">${formatDatePrint(z.pz_datum_pocetka_rada) || '&nbsp;'}</span><span style="margin-left:4px">1)</span></div>

<div class="sp"></div>
<div class="br"><span class="bl">Vrsta i opis promjene / Lloji dhe përshkrimi i ndryshimit</span><span class="bv">${z.pz_vrsta_promjene || '&nbsp;'}</span><span style="margin-left:4px">2)</span></div>
<div class="sub-l">(preseljenje, promjena zanatstva, odjava zanatstva) (translokimi, ndryshimi i zejtarisë, lajmërimi i përfundimit)</div>

<div class="sp"></div>
<div class="br"><span class="bl">Datum nastanka promjene iz prijave</span><span class="bv">${formatDatePrint(z.pz_datum_promjene) || '&nbsp;'}</span><span style="margin-left:4px">2)</span></div>
<div class="sub-l">Data e fillimit të ndryshimit nga fletëparaqitja</div>

<div class="sp"></div>
<div class="br"><span class="bl">Datum podnošenja prijave / Data e paraqitjes së fletëparaqitjes:</span><span class="bv">${formatDatePrint(z.datum_podnosenja) || '&nbsp;'}</span></div>

<div class="sign">
  <div class="sign-l">(Ime i prezime i potpis podnosioca prijave / Emri e mbiemri dhe firma e parashtruesit të fletëparaqitjes)</div>
</div>

<div class="uput">
  <div class="uput-t">Uputstvo za popunjavanje / Udhëzime për plotësim:</div>
  Prijava se podnosi organu lokalne uprave nadležnom za poslove privrede / Fletëparaqitja i paraqitet organit të administratës lokale kompetent për çështje ekonomike;<br>
  Predmet prijave označava se unošenjem znaka X / Subjekti i fletëparaqitjes shënohet me shenjën X;<br>
  Podaci o vrsti poslovne prostorije (tač. 2 i 3) popunjavaju se unošenjem znaka X na odgovarajućem mjestu / Të dhënat për ambientin afarist (pika 2 dhe 3) plotësohen duke shënuar shenjën X në vendin përkatës;<br>
  ***Izjava se odnosi i na uslove kod promjene podataka / Deklarata ka të bëjë edhe me kushtet te ndryshimi i të dhënave.
</div>
<div class="taxa">
  Dokaz o izvršenoj uplati administrativne takse od / Dëshminë e pagesës së taksës administrative prej 3,00 €,<br>
  ŽR/XhLl 540-82567770-12 – Opština Ulcinj / Komuna e Ulqinit
</div>
<div class="meta">Kreirao: ${z.created_by_name || 'N/A'} | FINANCE GROUP CRM</div>
</div>
<script>window.onload=function(){window.print();window.onafterprint=function(){window.close()}}</script></body></html>`;
  };

  const handlePrint = (z) => printHTML(buildHtml(z));
  const handleWord = (z) => downloadWord(buildHtml(z), `Prijava_zanatstva_${(z.pz_naziv_ime||'naziv').replace(/\s+/g,'_')}.doc`);

  return (
    <div className="space-y-6" data-testid="prijava-zanatstva-page">
      <div className="flex justify-between items-center">
        <div><h3 className="text-lg font-medium text-slate-900">Prijava zanatstva</h3><p className="text-sm text-slate-600 mt-1">Prijava početka obavljanja / promjena podataka</p></div>
        <Button onClick={() => {setForm(emptyForm);setEditingId(null);setIsFormOpen(true);}} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="pz-add-btn"><Plus size={20} weight="bold" className="mr-2" /> Nova prijava</Button>
      </div>
      {loading ? <p className="text-center text-slate-500 py-16">Učitavanje...</p> : zahtjevi.length === 0 ? (
        <Card className="p-8 text-center"><Hammer size={48} weight="duotone" className="text-slate-400 mx-auto mb-4" /><p className="text-slate-500">Nema prijava zanatstva</p></Card>
      ) : (
        <Card className="overflow-hidden"><div className="overflow-x-auto"><table className="w-full text-left text-sm text-slate-600" data-testid="pz-table"><thead className="bg-slate-50 border-b"><tr>
          <th className="px-4 py-3 text-xs font-semibold uppercase text-slate-500">Datum</th>
          <th className="px-4 py-3 text-xs font-semibold uppercase text-slate-500">Naziv/Ime</th>
          <th className="px-4 py-3 text-xs font-semibold uppercase text-slate-500">Predmet</th>
          <th className="px-4 py-3 text-xs font-semibold uppercase text-slate-500">PIB</th>
          <th className="px-4 py-3 text-xs font-semibold uppercase text-slate-500">Formirao</th>
          <th className="px-4 py-3 text-xs font-semibold uppercase text-slate-500">Akcije</th>
        </tr></thead><tbody>{zahtjevi.map(z=>(
          <tr key={z.id} className="border-b hover:bg-slate-50">
            <td className="px-4 py-3 text-xs">{formatDatePrint(z.datum_podnosenja)||'-'}</td>
            <td className="px-4 py-3 font-medium">{z.pz_naziv_ime||'-'}</td>
            <td className="px-4 py-3"><span className={`px-2 py-1 rounded text-xs font-medium border ${z.pz_predmet_prijave==='pocetak'?'bg-green-50 text-green-700 border-green-200':'bg-amber-50 text-amber-700 border-amber-200'}`}>{z.pz_predmet_prijave==='pocetak'?'Početak':'Promjena'}</span></td>
            <td className="px-4 py-3 text-sm">{z.pz_poreski_broj||'-'}</td>
            <td className="px-4 py-3 text-sm text-slate-600">{z.created_by_name||'-'}</td>
            <td className="px-4 py-3"><div className="flex gap-1">
              <button onClick={()=>handlePrint(z)} className="p-2 hover:bg-green-100 rounded" title="Štampaj" data-testid={`pz-print-${z.id}`}><Printer size={16} className="text-green-600"/></button>
              <button onClick={()=>handleWord(z)} className="p-2 hover:bg-indigo-100 rounded" title="Word dokument" data-testid={`pz-word-${z.id}`}><FileDoc size={16} className="text-indigo-600"/></button>
              <button onClick={()=>handleEdit(z)} className="p-2 hover:bg-slate-200 rounded" data-testid={`pz-edit-${z.id}`}><Pencil size={16} className="text-slate-600"/></button>
              <button onClick={()=>handleDelete(z.id)} className="p-2 hover:bg-red-100 rounded" data-testid={`pz-delete-${z.id}`}><Trash size={16} className="text-red-600"/></button>
            </div></td>
          </tr>))}</tbody></table></div></Card>
      )}
      <Dialog open={isFormOpen} onOpenChange={setIsFormOpen}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="pz-form-dialog">
          <DialogHeader><DialogTitle>{editingId?'Uredi prijavu zanatstva':'Nova prijava zanatstva'}</DialogTitle></DialogHeader>
          <div className="space-y-4 mt-4">
            <Card className="p-3 bg-blue-50 border-blue-200"><Label className="text-xs font-semibold uppercase text-blue-700 mb-2 block">Auto-popunjavanje iz klijenta</Label><ClientAutocomplete clients={clients} value={form.client_id} onChange={(id) => (v=>v!=='none'&&handleClientSelect(v))(id || 'none')} testid="pz-client-select" placeholder="Pretraga po nazivu ili PIB-u..." /></Card>

            <div><Label className="text-xs font-semibold uppercase text-slate-500">Predmet prijave</Label>
            <div className="flex gap-3 mt-1"><button type="button" onClick={()=>setForm({...form,pz_predmet_prijave:'pocetak'})} className={`flex-1 px-4 py-2.5 rounded-md text-sm font-bold border-2 ${form.pz_predmet_prijave==='pocetak'?'bg-green-600 text-white border-green-600':'bg-white text-green-600 border-green-300'}`}>Početak obavljanja</button><button type="button" onClick={()=>setForm({...form,pz_predmet_prijave:'promjena'})} className={`flex-1 px-4 py-2.5 rounded-md text-sm font-bold border-2 ${form.pz_predmet_prijave==='promjena'?'bg-amber-600 text-white border-amber-600':'bg-white text-amber-600 border-amber-300'}`}>Promjena podataka</button></div></div>

            <h4 className="text-sm font-semibold border-b pb-2">1. Podaci o zanatliji</h4>
            <div><Label className="text-xs font-semibold uppercase text-slate-500">Naziv / Ime *</Label><Input value={form.pz_naziv_ime} onChange={e=>setForm({...form,pz_naziv_ime:e.target.value})} className="bg-white border-slate-300" data-testid="pz-naziv-input"/></div>
            <div><Label className="text-xs font-semibold uppercase text-slate-500">Sjedište, adresa</Label><Input value={form.pz_sjediste_adresa} onChange={e=>setForm({...form,pz_sjediste_adresa:e.target.value})} className="bg-white border-slate-300"/></div>
            <div><Label className="text-xs font-semibold uppercase text-slate-500">Broj i datum rješenja o upisu u Centralni Registar</Label><Input value={form.pz_broj_rjesenja} onChange={e=>setForm({...form,pz_broj_rjesenja:e.target.value})} className="bg-white border-slate-300"/></div>
            <div className="grid grid-cols-2 gap-3"><div><Label className="text-xs font-semibold uppercase text-slate-500">Šifra djelatnosti</Label><Input value={form.pz_sifra_djelatnosti} onChange={e=>setForm({...form,pz_sifra_djelatnosti:e.target.value})} className="bg-white border-slate-300"/></div><div><Label className="text-xs font-semibold uppercase text-slate-500">PIB</Label><Input value={form.pz_poreski_broj} onChange={e=>setForm({...form,pz_poreski_broj:e.target.value})} className="bg-white border-slate-300"/></div></div>
            <div className="grid grid-cols-2 gap-3"><div><Label className="text-xs font-semibold uppercase text-slate-500">Ovlašćeno lice (direktor)</Label><Input value={form.pz_ovlasceno_lice} onChange={e=>setForm({...form,pz_ovlasceno_lice:e.target.value})} className="bg-white border-slate-300"/></div><div><Label className="text-xs font-semibold uppercase text-slate-500">Br. lične karte / pasoša</Label><Input value={form.pz_broj_licne_karte} onChange={e=>setForm({...form,pz_broj_licne_karte:e.target.value})} className="bg-white border-slate-300"/></div></div>
            <div><Label className="text-xs font-semibold uppercase text-slate-500">Žiro račun/i i poslovna banka</Label><Input value={form.pz_ziro_racun} onChange={e=>setForm({...form,pz_ziro_racun:e.target.value})} className="bg-white border-slate-300"/></div>
            <div><Label className="text-xs font-semibold uppercase text-slate-500">Telefon, fax, e-mail</Label><Input value={form.pz_telefon_fax_email} onChange={e=>setForm({...form,pz_telefon_fax_email:e.target.value})} className="bg-white border-slate-300"/></div>

            <h4 className="text-sm font-semibold border-b pb-2">2. Vrsta zanata</h4>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs font-semibold uppercase text-slate-500">Vrsta zanata</Label>
              <Select value={form.pz_vrsta_zanata||'none'} onValueChange={v=>setForm({...form,pz_vrsta_zanata:v==='none'?'':v})}><SelectTrigger className="bg-white border-slate-300"><SelectValue placeholder="Izaberite"/></SelectTrigger><SelectContent><SelectItem value="none">-- Izaberite --</SelectItem><SelectItem value="jednostavni">Jednostavni zanati</SelectItem><SelectItem value="slozeni">Složeni zanati</SelectItem></SelectContent></Select></div>
              <div><Label className="text-xs font-semibold uppercase text-slate-500">Osnovna / Dopunska</Label>
              <Select value={form.pz_osnovna_dopunska} onValueChange={v=>setForm({...form,pz_osnovna_dopunska:v})}><SelectTrigger className="bg-white border-slate-300"><SelectValue/></SelectTrigger><SelectContent><SelectItem value="osnovna">Osnovna djelatnost</SelectItem><SelectItem value="dopunska">Dopunska djelatnost</SelectItem></SelectContent></Select></div>
            </div>
            <div><Label className="text-xs font-semibold uppercase text-slate-500">Zanatska djelatnost</Label><Input value={form.pz_zanatska_djelatnost} onChange={e=>setForm({...form,pz_zanatska_djelatnost:e.target.value})} className="bg-white border-slate-300"/></div>
            <div><Label className="text-xs font-semibold uppercase text-slate-500">Prostor</Label>
            <Select value={form.pz_prostor_tip} onValueChange={v=>setForm({...form,pz_prostor_tip:v})}><SelectTrigger className="bg-white border-slate-300"><SelectValue/></SelectTrigger><SelectContent><SelectItem value="poslovni">U poslovnoj prostoriji</SelectItem><SelectItem value="stambeni">U stambenoj prostoriji</SelectItem></SelectContent></Select></div>

            <h4 className="text-sm font-semibold border-b pb-2">3. Podaci o prostoriji</h4>
            <div className="grid grid-cols-2 gap-3"><div><Label className="text-xs font-semibold uppercase text-slate-500">Sjedište</Label><Input value={form.pz_pp_sjediste} onChange={e=>setForm({...form,pz_pp_sjediste:e.target.value})} className="bg-white border-slate-300"/></div><div><Label className="text-xs font-semibold uppercase text-slate-500">Adresa</Label><Input value={form.pz_pp_adresa} onChange={e=>setForm({...form,pz_pp_adresa:e.target.value})} className="bg-white border-slate-300"/></div></div>
            <div className="grid grid-cols-2 gap-3">
              <label className="flex items-center gap-2 p-2 border rounded"><input type="checkbox" checked={form.pz_pp_poslovni} onChange={e=>setForm({...form,pz_pp_poslovni:e.target.checked})} className="accent-blue-600"/> Poslovni prostor <Input value={form.pz_pp_poslovni_m2} onChange={e=>setForm({...form,pz_pp_poslovni_m2:e.target.value})} placeholder="m²" className="w-20 ml-auto bg-white border-slate-300 text-xs"/></label>
              <label className="flex items-center gap-2 p-2 border rounded"><input type="checkbox" checked={form.pz_pp_stambeni} onChange={e=>setForm({...form,pz_pp_stambeni:e.target.checked})} className="accent-blue-600"/> Stambeni prostor <Input value={form.pz_pp_stambeni_m2} onChange={e=>setForm({...form,pz_pp_stambeni_m2:e.target.value})} placeholder="m²" className="w-20 ml-auto bg-white border-slate-300 text-xs"/></label>
            </div>

            <h4 className="text-sm font-semibold border-b pb-2">5-8. Datumi</h4>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs font-semibold uppercase text-slate-500">Datum početka rada</Label><DateInput value={form.pz_datum_pocetka_rada} onChange={e=>setForm({...form,pz_datum_pocetka_rada:e.target.value})} className="border-slate-300"/></div>
              <div><Label className="text-xs font-semibold uppercase text-slate-500">Datum podnošenja</Label><DateInput value={form.datum_podnosenja} onChange={e=>setForm({...form,datum_podnosenja:e.target.value})} className="border-slate-300"/></div>
            </div>
            {form.pz_predmet_prijave === 'promjena' && <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs font-semibold uppercase text-slate-500">Vrsta i opis promjene</Label><Input value={form.pz_vrsta_promjene} onChange={e=>setForm({...form,pz_vrsta_promjene:e.target.value})} className="bg-white border-slate-300" placeholder="preseljenje, promjena zanatstva..."/></div>
              <div><Label className="text-xs font-semibold uppercase text-slate-500">Datum promjene</Label><DateInput value={form.pz_datum_promjene} onChange={e=>setForm({...form,pz_datum_promjene:e.target.value})} className="border-slate-300"/></div>
            </div>}

            <div className="flex gap-3 justify-end pt-4 border-t"><Button variant="outline" onClick={()=>setIsFormOpen(false)}>Odustani</Button><Button onClick={handleSubmit} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="pz-submit-btn">{editingId?'Ažuriraj':'Kreiraj'}</Button></div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
